// consts.ts
export interface BlogCard {
  id: number;
  blogId: string;
  img: string;
  title: string;
  description: string;
  buttonText: string;
}

export const BLOGS_DATA: BlogCard[] = [
  {
    id: 1,
    blogId: "check-the-safest-and-surest-way-to-check-loose-dropping-in-poultry",
    img: "/img/blogs/blog_1.jpg",
    title: "CHECK® - THE SAFEST AND SUREST WAY TO CHECK LOOSE DROPPING IN POULTRY",
    description:
      "Loose droppings, or diarrhoea, are among the most common and concerning issues in poultry farming. They not only affect bird comfort .....",
    buttonText: "Know More",
  },
  {
    id: 2,
    blogId: "biofence-stage-I-day-old-chick-spray",
    img: "/img/blogs/blog_2.png",
    title: "BIOFENCE® STAGE-I – Day old chick spray for Maximum Liveability, Immunity and Growth",
    description:
      "Hatcheries for chicks provide controlled conditions, including optimal temperature, humidity, and biosecurity. Chicks leaving the hatchery face a sudden and profound challenge.",
    buttonText: "Know More",
  },
  {
    id: 3,
    blogId: "redefining-feed-additives-intron-global-benchmark",
    img: "/img/blogs/blog_3.jpeg",
    title: "Redefining Feed Additives: How INTRON's Concepts Set a New Global Benchmark in the Animal Health Industry",
    description:
      "The global animal health industry is at a turning point - where performance must align with sustainability, safety, and antibiotic-free production.",
    buttonText: "Know More",
  },
];
